export class Permissions implements IPermissions{
    administration?: AdminMenus;
    indexes?: IndexMenus;
    workspace?: WorkspaceMenus;

    public constructor(d: Permissions) {
        this.administration = new AdminMenus(d?.administration);
        this.indexes = new IndexMenus(d?.indexes);
        this.workspace = new WorkspaceMenus(d?.workspace);
    }
}

export interface IPermissions {
    administration?: AdminMenus;
    indexes?: IndexMenus;
    workspace?: WorkspaceMenus;
}

export interface IRights {
    edit: boolean;
    create: boolean;
    remove: boolean;
    view: boolean;
}

export class Rights implements IRights {
    edit: boolean;
    create: boolean;
    remove: boolean;
    view: boolean;

    public constructor(d?: Rights) {
        this.edit = d?.edit;
        this.create = d?.create;
        this.remove = d?.remove;
        this.view = d?.view;
    }
}

export interface IWorkspaceMenus {
    clients?: Rights;
    sold_tos?: Rights;
    ship_tos?: Rights;
    loading_sites?: Rights;
    contacts?: Rights;
    products?: Rights;
    users?: Rights;
    currencies?: Rights;
}

export class WorkspaceMenus implements IWorkspaceMenus {
    clients?: Rights;
    sold_tos?: Rights;
    ship_tos?: Rights;
    loading_sites?: Rights;
    contacts?: Rights;
    products?: Rights;
    users?: Rights;
    currencies?: Rights;
    
    public constructor(d: WorkspaceMenus) {
        this.clients = new Rights(d.clients);
        this.sold_tos = new Rights(d.sold_tos);
        this.ship_tos = new Rights(d.ship_tos);
        this.loading_sites = new Rights(d.loading_sites);
        this.contacts = new Rights(d.contacts);
        this.products = new Rights(d.products);
        this.users = new Rights(d.users);
        this.currencies = new Rights(d.currencies);
    }
}

export interface IIndexMenus {
    platts?: Rights;
    icis?: Rights;
}

export class IndexMenus implements IIndexMenus {
    platts?: Rights;
    icis?: Rights;

    public constructor (d: IndexMenus) {
        this.platts = new Rights(d.platts);
        this.icis = new Rights(d.icis);
    }
}

export interface IAdministrationMenus {
    users?: Rights;
    workspaces?: Rights;
    indexes?: Rights;
    sales_organisations?: Rights;
    loading_sites?: Rights;
    currencies?: Rights;
    packagings?: Rights;
}

export class AdminMenus implements IAdministrationMenus {
    users?: Rights;
    workspaces?: Rights;
    indexes?: Rights;
    sales_organisations?: Rights;
    loading_sites?: Rights;
    currencies?: Rights;
    packagings?: Rights;

    public constructor(d: AdminMenus) { 
        this.users = new Rights(d.users);
        this.workspaces = new Rights(d.workspaces);
        this.sales_organisations = new Rights(d.sales_organisations);
        this.loading_sites = new Rights(d.loading_sites);
        this.currencies = new Rights(d.currencies);
        this.packagings = new Rights(d.packagings);
        this.indexes = new Rights(d.indexes);
    }
}